import {ILink} from "../../interfaces/components/utility/ILink";
import * as React from "react";
import {ReactElement} from "react";
import {Button, Typography} from "@mui/material";
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

interface IProps extends ILink {

}

export default function LinkButton({name, address, prefix}: IProps): ReactElement {
    const handleButtonClick = () => {
        window.open(address, '_blank');
    };

    return (
        <Button
            aria-label="Link"
            variant="contained"
            color="primary"
            onClick={handleButtonClick}
        >
            <Typography
                    color={"textSecondary"}
                    variant={"h6"}
            >

            {`${prefix} ${name}`}
            </Typography>
            <OpenInNewRoundedIcon sx={{ paddingLeft: 1}} />
        </Button>
    );
}
